module.exports = __webpack_public_path__ + "static/media/dataWallet.deaec3f6.png";